import { AppApiService } from './app-api.service';
import {StatisticsResponse} from "../models/interfaces/statistics-dto.interface";

class StatisticsApiService extends AppApiService {
    public async getStatistics(): Promise<StatisticsResponse> {
        return await this.get<StatisticsResponse>('/statistics', {
            errorMessage: 'Błąd podczas pobierania statystyk',
            skipDefault404Handling: true,
        }).catch((error) => {
            throw error;
        });
    }
}

export default new StatisticsApiService();
